import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getValidSession } from "../../pages/helpers/sessionUtils";
import ReactDOM from "react-dom";
import { useVendorAuth } from "../../context/VendorAuthContext";


const ASSET_BASE_PATH = `${process.env.PUBLIC_URL}/admin-assets`;

const Sidebar = () => {
  const [isListingOpen, setIsListingOpen] = useState(true);
  const [showMedicalModal, setShowMedicalModal] = useState(false);
  const navigate = useNavigate();
  const { vendor } = useVendorAuth();
  const registrationStep = Number(vendor?.last_registration_step ?? 0);

  const toggleSidebar = () => {
    const currentSize = document.documentElement.getAttribute('data-sidebar-size');
    if (currentSize === 'sm') {
      document.documentElement.setAttribute('data-sidebar-size', 'lg');
    } else {
      document.documentElement.setAttribute('data-sidebar-size', 'sm');
    }
  };

  const closeSidebar = () => {
    if (document.body.classList.contains("vertical-sidebar-enable")) {
      document.body.classList.remove("vertical-sidebar-enable");
    }
  };

  const toggleListing = (e) => {
    e.preventDefault();
    setIsListingOpen(!isListingOpen);
  };

  // const handleDoctorRegister = () => {
  //   setShowMedicalModal(false);
  //   navigate("/admin/medical-tourism-doctors");
  // };

  // const handleHospitalRegister = () => {
  //   setShowMedicalModal(false);
  //   navigate("/admin/medical-tourism-hospitals");
  // };

  useEffect(() => {
    if (showMedicalModal) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }

    return () => document.body.classList.remove("modal-open");
  }, [showMedicalModal]);


  useEffect(() => {

    console.log(
      "Sidebar mounted. React state managing collapse."
    );
  }, []);

  return (
    <div className="app-menu navbar-menu">
      <div className="navbar-brand-box">
        <Link to="/admin" className="logo logo-dark">
          <span className="logo-sm">
            <img
              src="/mangoloops-fevicon.png"
              alt="Mangoloops"
              height="22"
            />
          </span>
          <span className="logo-lg">
            <img
              src="/logo-mangoloops.png"
              alt="Mangoloops"
              height="30"
            />
          </span>
        </Link>

        <Link to="/admin" className="logo logo-light">
          <span className="logo-sm">
            <img
              src="/mangoloops-fevicon.png"
              alt="Mangoloops"
              height="22"
            />
          </span>
          <span className="logo-lg">
            <img
              src="/logo-mangoloops.png"
              alt="Mangoloops"
              height="30"
            />
          </span>
        </Link>
        <button
          type="button"
          className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
          id="vertical-hover"
          onClick={toggleSidebar}
        >
          <i className="ri-record-circle-line"></i>
        </button>
        <button
          type="button"
          className="btn btn-sm p-0 fs-20 header-item float-end d-none-desktop"
          id="sidebar-close-btn"
          onClick={closeSidebar}
          style={{ display: 'none' }} // We will control this via CSS or just use existing theme classes if available
        >
          <i className="ri-close-line fs-24"></i>
        </button>
      </div>

      <div id="scrollbar" data-simplebar className="h-400">
        <div className="container-fluid">
          <div id="two-column-menu">
            {/* Content for two-column menu if used by the theme */}
          </div>
          <ul className="navbar-nav" id="navbar-nav">
            <li className="menu-title">
              <span data-key="t-menu">Menu</span>
            </li>

            {/* Dashboards */}
            <li className="nav-item">
              <Link to="/admin/dashboard" className="nav-link menu-link" onClick={closeSidebar}>
                <i className="mdi mdi-speedometer"></i>{" "}
                <span data-key="t-dashboards">Dashboards</span>
              </Link>
            </li>

            {/* Menus are always visible; AdminLayout handles the restricted redirects if KYC is incomplete */}
                <li className="nav-item">
                  <Link to="/admin/my-leads" className="nav-link menu-link" onClick={closeSidebar}>
                    <i className="mdi mdi-account-convert"></i>{" "}
                    <span data-key="t-leads">My Leads</span>
                  </Link>
                </li>

                {/* Manage Listing */}
                <li className="nav-item">
                  <a
                    className={`nav-link menu-link ${isListingOpen ? "" : "collapsed"}`}
                    href="#sidebarManageListing"
                    onClick={toggleListing}
                    role="button"
                    aria-expanded={isListingOpen}
                    aria-controls="sidebarManageListing"
                  >
                    <i className="mdi mdi-grid-large"></i>{" "}
                    <span data-key="t-pages">Manage Listing</span>
                  </a>
                  <div className={`collapse menu-dropdown ${isListingOpen ? "show" : ""}`} id="sidebarManageListing">
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        <Link
                          to="/admin/holiday-packages"
                          className="nav-link"
                          data-key="t-tour-packages"
                          onClick={closeSidebar}
                        >
                          Tour Packages
                        </Link>
                      </li>

                      <li className="nav-item">
                        <Link
                          to="/admin/hotels"
                          className="nav-link"
                          data-key="t-hotels"
                          onClick={closeSidebar}
                        >
                          Hotels
                        </Link>
                      </li>

                      <li className="nav-item">
                        <Link
                          to="/admin/cabs"
                          className="nav-link"
                          data-key="t-cabs"
                          onClick={closeSidebar}
                        >
                          Cabs
                        </Link>
                      </li>

                      <li className="nav-item">
                        <button
                          type="button"
                          className="nav-link btn btn-link text-start w-100"
                          onClick={() => {
                            setShowMedicalModal(true);
                            closeSidebar();
                          }}
                        >
                          Medical Tourism
                        </button>
                      </li>
                    </ul>
                  </div>
                </li>

                <li className="menu-title">
                  <i className="ri-more-fill"></i>{" "}
                  <span data-key="t-components">Components</span>
                </li>

                <li className="nav-item">
                  <Link
                    to="/admin/subscriptions"
                    className="nav-link menu-link"
                  >
                    <i className="mdi mdi-card-bulleted-outline"></i>
                    <span data-key="t-subscriptions">My Subscription</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/admin/change-password" name="change-password" id="change-password" className="nav-link menu-link" onClick={closeSidebar}>
                    <i className="ri-lock-password-line"></i>{" "}
                    <span data-key="t-dashboards"> Change Password</span>
                  </Link>
                </li>

            <li className="nav-item">
              <Link
                to="/admin/kyc-verification"
                className="nav-link menu-link"
                onClick={closeSidebar}
              >
                <i className="ri-checkbox-circle-line"></i>
                <span data-key="t-kyc-verification">KYC Verification</span>
              </Link>
            </li>

            <li className="nav-item">
              {registrationStep >= 6 ? (
                <Link
                  to="/admin/profile-setup"
                  className="nav-link menu-link"
                  onClick={closeSidebar}
                >
                  <i className="ri-user-settings-line"></i>
                  <span data-key="t-profile-setup">Profile Setup</span>
                </Link>
              ) : (
                <span
                  className="nav-link menu-link text-muted"
                  style={{ cursor: 'not-allowed', opacity: 0.6 }}
                  title="Complete KYC Verification to unlock Profile Setup"
                >
                  <i className="ri-user-settings-line"></i>
                  <span data-key="t-profile-setup">Profile Setup (Locked)</span>
                </span>
              )}
            </li>

          </ul>
        </div>
      </div>
      <div className="sidebar-background"></div>

      {showMedicalModal &&
        ReactDOM.createPortal(
          <>
            <div className="modal fade show d-block" tabIndex="-1">
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">

                  <div className="modal-header">
                    <h5 className="modal-title">Medical Tourism</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowMedicalModal(false)}
                    />
                  </div>

                  <div className="modal-body text-center">
                    <p>Please select one option</p>

                    <button
                      className="btn btn-primary w-100 mb-2"
                      onClick={() => {
                        setShowMedicalModal(false);
                        navigate("/admin/medical-tourism-doctors");
                      }}
                    >
                      Continue as a Doctor
                    </button>

                    <button
                      className="btn btn-success w-100"
                      onClick={() => {
                        setShowMedicalModal(false);
                        navigate("/admin/medical-tourism-hospitals");
                      }}
                    >
                      Register as a Hospital
                    </button>
                  </div>

                </div>
              </div>
            </div>

            <div
              className="modal-backdrop fade show"
              onClick={() => setShowMedicalModal(false)}
            />
          </>,
          document.body
        )
      }


      <style>{`
        body.modal-open #layout-wrapper,
        body.modal-open .main-content,
        body.modal-open .page-content {
          filter: none !important;
          transition: filter 0.2s ease;
          z-index: 2000;
        }

        .modal,
        .modal * {
          filter: none !important;
        }

        .modal {
          z-index: 1055;
        }

        .modal-backdrop {
          z-index: 1050;
          background-color: rgba(0,0,0,0.5);
        }

        #scrollbar {
          height: calc(100vh - 70px);
          overflow-y: auto !important;
          overflow-x: hidden;
        }

        /* Hide standard scrollbar but allow scrolling */
        #scrollbar::-webkit-scrollbar {
          width: 5px;
        }
        #scrollbar::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 10px;
        }
        #scrollbar:hover::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.2);
        }

        @media (max-width: 767px) {
          #sidebar-close-btn {
            display: block !important;
            position: absolute;
            right: 10px;
            top: 20px;
            color: #fff;
          }
          #vertical-hover {
            display: none !important;
          }
        }
      `}</style>

    </div>



  );
};

export default Sidebar;
